/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import { datePickerWrapperCss, labelCss } from "./index.css";
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerInput({ label, ...rest }) {
  return (
    <div css={datePickerWrapperCss}>
      <label htmlFor="datePickerInput" css={labelCss}>
        {label}
      </label>

      <DatePicker autoComplete="off" id="datePickerInput" {...rest} />
    </div>
  );
}

DatePickerInput.propTypes = {
  label: PropTypes.string,
};
